export interface IEventLog {
    type: EventLogType;
    message: string;
    when: Date;
}

export enum EventLogType {
    WARNING = "warning",
    INFO = "info",
    ERROR = "error",
}

export class EventLog implements IEventLog {
    type: EventLogType = EventLogType.INFO;
    message: string;
    when: Date = new Date();

    constructor(message: string, type?: EventLogType) {
        this.message = message;

        if (type) this.type = type;
    }
}
